import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';
import type { AddRemixHistoryEntryPayload } from '@atlassian/malleable-ui-components/types';

import {
	type RemixHistoryPluginMeta,
	remixHistoryPluginKey,
} from '../pm-plugins/remix-history/remix-history-plugin';

export function makeAddRemixHistoryEntryCommand(
	options: AddRemixHistoryEntryPayload,
): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(remixHistoryPluginKey, {
			payload: options,
			type: 'addHistoryEntry',
		} satisfies RemixHistoryPluginMeta);
		return tr;
	};
}
